import { AppState } from "../rootReducer";

export const getScrollTop = (state: AppState) => state.nav.scrollTop;

export const getRoute = (state: AppState) => state.nav.route;

export const getPrevRoute = (state: AppState) => state.nav.prevRoute;

export const getAppState = (state: AppState) => state.nav.appState;

export const getIsTopSafeAreaHidden = (state: AppState) => state.nav.isTopSafeAreaHidden || false;